import { adminClient, twoFactorClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

const API_BASE = import.meta.env.VITE_API_URL ?? 'https://api.lookbookiq.app'

export const authClient = createAuthClient({
  baseURL: API_BASE,
  basePath: '/auth',
  plugins: [adminClient(), twoFactorClient()],
})

export const { signIn, signOut, signUp, useSession } = authClient
